import React, { PureComponent } from 'react'
import { CategoryDictionaryHelper } from '../helper'
import styled from 'styled-components'
import { QuestionType } from './'

const Title = styled.h4`
  border-bottom: 1px solid #ddd;
  margin: 20px 0;
`

class CategoryQuestions extends PureComponent {
  renderQuestions = () => {
    const {
      props: { questions, entity, isEditable }
    }= this

    return (
      questions.map((q, i) => (
        <QuestionType
          ref={q.rid}
          entity={entity}
          question={q}
          key={i}
          answers={entity.answers}
          questions={entity.questions}
          disabled={!isEditable}
        />
      ))
    )
  }
  render() {
    const {
      props: { questions, category },
      renderQuestions
    }= this
    const { categoryName } = CategoryDictionaryHelper
    const title = categoryName(category)

    return (
      <>
        {title && (
          <Title>
            {title}
          </Title>
        )}
        {questions.length > 0 ? (
            renderQuestions()
          ) : (
            <p>There are no questions for this category.</p>
          )
        }
      </>
    )
  }
}

export default CategoryQuestions
